import ClaimsList from "../views/ClaimsList"
import ClaimDetail from "../views/ClaimDetail"
import ClaimCreate from "../views/ClaimCreate"
import ClaimTransactions from "../views/ClaimTransactions"
import ClaimLogs from "../views/ClaimLogs"

export default [
	{
		path: "/:tenantId/claims",
		component: ClaimsList,
		name: "ClaimsList",
		meta: { featureId: "claims" },
		props: true
	},
	{
		path: "/:tenantId/claims/create",
		component: ClaimCreate,
		name: "ClaimCreate",
		meta: { featureId: "claims" },
		props: true
	},
	{
		path: "/:tenantId/claims/detail/:id",
		component: ClaimDetail,
		name: "ClaimDetail",
		meta: { featureId: "claims" },
		props: true
	},
	{
		path: "/:tenantId/claims/detail/:id/transactions",
		component: ClaimTransactions,
		name: "ClaimTransactions",
		meta: { featureId: "claims" },
		props: true
	},
	{
		path: "/:tenantId/claims/detail/:id/logs",
		component: ClaimLogs,
		name: "ClaimLogs",
		meta: { featureId: "claims" },
		props: true
	}
]
